export const SELLER_PACKAGE_STATES = {
  PENDING_DROPOFF: "PENDING_DROPOFF",
  DROPPED_OFF: "DROPPED_OFF",
  RECEIVED_AT_WAREHOUSE: "RECEIVED_AT_WAREHOUSE",
  UNDER_REVIEW: "UNDER_REVIEW",
  REVIEWED: "REVIEWED",
  COMPLETED: "COMPLETED",
};

export const SELLER_PACKAGE_STATES_LABELS = {
  [SELLER_PACKAGE_STATES.PENDING_DROPOFF] : "Pending Dropoff",
  [SELLER_PACKAGE_STATES.DROPPED_OFF] : "Dropped Off",
  [SELLER_PACKAGE_STATES.RECEIVED_AT_WAREHOUSE] : "Received",
  [SELLER_PACKAGE_STATES.UNDER_REVIEW] : "Under Review",
  [SELLER_PACKAGE_STATES.REVIEWED] : "Reviewed",
  [SELLER_PACKAGE_STATES.COMPLETED] : "Completed",
}

export const PACKAGE_ITEM_STATE_GROUPS = {
  PRE_OFFER: [
    "UNPACKED",
    "UNDER_REVIEW",
    "APPROVED",
    "APPROVED_WITH_CONDITION",
    "PENDING_UNLIST",
    "UNLISTED"
  ],
  REJECTED: [
    "OFFER_REJECTED",
    "REJECTED",
    "SCHEDULED_FOR_DONATION",
    "SCHEDULED_FOR_RETURN",
    "DONATED",
    "IN_TRANSIT_FOR_RETURN",
    "RETURNED"
  ],
  NEGOTIABLE: ["OFFER_PLACED"],
  PREPARING: [
    "OFFER_ACCEPTED",
    "REPAIRING",
    "PREPARING_LISTING",
    "PENDING_LISTING",
  ],
  LISTED: ["LISTED", "SOLD"]
};

export function getTaskLabelByType (taskKey: string) {
  return taskKey[0].toUpperCase() + taskKey.substring(1);
}

export const COMMISSION_TIER = {
  TWO: '2',
  THREE: '3'
}

export function calculateSellerEarningOnPrice (price: number, commissionTier: string) {
  switch (commissionTier) {
    case COMMISSION_TIER.THREE:
      if (!price) return 0;
      if (price <= 300) return price - 150;
      if (price <= 669) return price - 200;
      else return Math.round(price * 0.7);
    case COMMISSION_TIER.TWO:
    default:
      if (!price) return 0;
      if (price <= 750) return price - 150;
      else return Math.round(price * 0.8);
  }
}
